import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { CardGrid } from '../CardGrid';
import { MiniPie } from '../MiniPie';
import { Chevron } from '../Chevron';
import { LinearGauge } from '../LinearGauge';
import { SortDirection, SortCriterion } from '../ListSortOptions';
import * as API from '../../API';
import './SectorResultGrid.scss';
export const SectorResultGrid = (props) => {
    const sectorResultRef = useRef([]);
    const infoRef = useRef(null);
    const [mostRecentYear, setMostRecentYear] = useState(null);
    const defaultSort = (a, b) => {
        const [l, r] = props.sortDir === SortDirection.asc ? [a, b] : [b, a];
        return props.sortDir === SortDirection.asc
            ? b.sektornavn.localeCompare(a.sektornavn, 'no-NO')
            : a.sektornavn.localeCompare(b.sektornavn, 'no-NO');
    };
    const sectorSort = (a, b) => {
        if (props.sortBy === SortCriterion.label) { // Already sorted by default
            return 0;
        }
        const [l, r] = props.sortDir === SortDirection.asc ? [a, b] : [b, a];
        return props.sortBy === SortCriterion.weight
            ? l.sektor_vekting - r.sektor_vekting
            : l.rangering - r.rangering;
    };
    useEffect(() => {
        API.mostRecentYear()
            .then(mry => setMostRecentYear(mry));
    }, []);
    const { data: municipalitySectorResultsData } = useQuery(`kb/kommuner/sektorresultater/${props.knr}/${mostRecentYear}`, () => API.fetchMunicipalitySectorResults(props.knr));
    const { data: municipalityInfoData } = useQuery(`kb/kommuner/${mostRecentYear}/${props.knr}`, () => API.fetchMunicipalityInfo(props.knr));
    if (municipalityInfoData) {
        infoRef.current = municipalityInfoData;
    }
    if (municipalitySectorResultsData) {
        sectorResultRef.current = Object.values(municipalitySectorResultsData);
        sectorResultRef.current.sort(defaultSort).sort(sectorSort);
    }
    const sectorResults = Object.values(sectorResultRef.current);
    const jsxSectors = sectorResults.slice().map((sec, index) => {
        var _a, _b, _c;
        const w = sec.sektor_vekting;
        const p = Math.round(sec.sektor_vekting * 1000) / 10;
        const rank = props.sortDir === SortDirection.asc
            ? index + 1
            : sectorResults.length - index;
        const jsxListPosition = props.sortBy === SortCriterion.ranking
            ? _jsx("i", { className: "badge rank", children: rank })
            : _jsx(MiniPie, { value: w, label: `${p}%`, className: "badge weight" });
        return (_jsxs("a", { className: `sector-result ${sec.sektorkode}`, title: `Klikk for flere detaljer om hvordan ${(_a = infoRef.current) === null || _a === void 0 ? void 0 : _a.kommune_navn} gjorde det innen ${(_b = sec.sektornavn) === null || _b === void 0 ? void 0 : _b.toLocaleLowerCase()}`, href: `#kommuner/${(_c = infoRef.current) === null || _c === void 0 ? void 0 : _c.kommune_knr}/sektorer/${sec.sektorkode}`, children: [jsxListPosition, _jsx("div", { className: "info", children: _jsx(LinearGauge, { label: _jsxs(_Fragment, { children: [sec.sektornavn, " ", _jsx(Chevron, { direction: "right" })] }), value: sec.rangering, max: 357, ranking: true, inverted: true }, `secor-result-griditem-${sec.sektorkode}`) })] }, sec.sektorkode));
    });
    return _jsx(CardGrid, Object.assign({}, props, { jsxCards: jsxSectors, className: 'sector-result-grid' }));
};
